<template>

  <BasicLayout>
    <div class="elevation-5">
      <v-toolbar flat="flat">
        <v-toolbar-title>Regions</v-toolbar-title>
      </v-toolbar>
      <TreeView :items="regions">
        <template slot="item" slot-scope="props">
          <td class="region-link" @click="details(props.item.item)">
            <RegionLink class="name" :id="props.item.item.id"></RegionLink>
          </td>
          <td class="actions">
            <v-dialog v-model="dialog" max-width="500px">
              <v-icon class="action" title="Add a sub-region" @click="create" slot="activator">mdi-plus</v-icon>
              <v-card>
                <v-card-title class="headline">{{ cardLabel }}</v-card-title>
                <v-card-text>
                  <v-text-field v-model="editing.name" label="Name"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat="flat" @click.native="close">{{ closeLabel }}</v-btn>
                  <v-btn v-if="editMode" color="primary" flat="flat" @click.native="save">{{ saveLabel }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </TreeView>
    </div>
  </BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'
import TreeView from '@/components/common/TreeView'
import EditDeleteButtons from '@/components/common/EditDeleteButtons'
import RegionLink from '@/components/links/Region'

export default {
  name: 'RegionsPage',
  components: {
    BasicLayout,
    TreeView,
    EditDeleteButtons,
    RegionLink
  },
  data () {
    return {
      dialog: null,
      editMode: false,
      editing: this.defaultRegion()
    }
  },
  computed: {
    regions () {
      const regions = Object.values(this.$store.state.regions)
      const tree = regions.filter(r => !r.parentId).map(r => ({item: r, id: r.id}))
      let added = [...tree]

      while (added.length !== 0) {
        const adding = []
        for (const region of added) {
          const childrens = regions.filter(r => r.parentId === region.item.id).map(r => ({item: r, id: r.id}))

          adding.push(...childrens)
          region.childrens = childrens
        }
        added = adding
      }
      return tree
    },

    cardLabel () {
      if (this.editMode) {
        return this.editing.id ? 'Edit a region' : 'Create a region'
      }
      return 'Details'
    },

    closeLabel () {
      return this.editMode ? 'Cancel' : 'Ok'
    },

    saveLabel () {
      return this.editing.id ? 'Save' : 'Create'
    }
  },
  methods: {
    defaultRegion () {
      return {
        id: null,
        parentID: null,
        name: null
      }
    },

    fetchRegions (parentID) {
      this.$store.dispatch('fetchRegions', parentID)
        .then(regions => {
          for (const region of regions.data) {
            this.fetchRegions(region.id)
          }
        })
        .catch((err) => {
          console.error('Failed to get subregions of ', parentID, err)
        })
    },

    create () {
      this.editMode = true
    },

    close () {
      this.editMode = false
      this.editing = this.defaultRegion()
      this.dialog = false
    },

    save () {
      if (this.editMode) {
        // TODO: create/patch here
      }
    },

    details (item) {
      this.$router.push(`/regions/${item.id}`)
      this.dialog = true
      this.editing.id = item.id
      this.editing.name = item.name
    }
  },
  mounted () {
    this.$store.dispatch('fetchSports')
    this.fetchRegions()
  }
}

</script>

<style lang="scss" scoped>

.region-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 50px;
  grid-template-areas: "name - actions";
  align-items: center;
}

.name {
  grid-area: name;
}

.actions {
  width: 100px;
}

.more, .buttons {
  display: inline;
}

.region-link {
  cursor: pointer;

  &:hover {
    // text-decoration: underline;
  }
}

.action {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/pages/Regions.vue